import type { FormulaEntry } from "../types/formula";

export const formulas: FormulaEntry[] = [
    // {
    //     category: ,
    //     name: '',
    //     description: '',
    //     latex: ''
    // },
    {
        category: 'Osnovne operacije',
        name: 'Zbrajanje',
        description: '1 plus 3 jednako je 4',
        latex: '1 +3 =4'
    },
    {
        category: 'Osnovne operacije',
        name: 'Oduzimanje',
        description: '10 minus 2 jednako je 8',
        latex: '10 -2 =8'
    },
    {
        category: 'Osnovne operacije',
        name: 'Množenje',
        description: '3 puta 4 jednako je 12',
        latex: '3 *4 =12'
    },
    {
        category: 'Osnovne operacije',
        name: 'Dijeljenje',
        description: '10 dijeljeno s 2 jednako je 5',
        latex: '10 :2 =5'
    },
    {
        category: 'Osnovne operacije',
        name: 'Eksponenti',
        description: 'X na potenciju Y',
        latex: 'X^{Y}'
    },
    {
        category: 'Osnovne operacije',
        name: 'Zbrajanje s eksponentima',
        description: '3 na drugu potenciju plus 4 na drugu potenciju jednako je 25',
        latex: '3^{2} +4^{2} =25'
    },
    {
        category: 'Razlomci',
        name: 'Razlomci',
        description: 'Razlomak 6 kroz 3 jednako je 2',
        latex: '\\raz{6}{3} =2'
    },
    {
        category: 'Korijeni',
        name: 'Drugi korijen',
        description: 'Drugi korijen iz X jednak je Y',
        latex: '\\kor{X} =Y'
    },
    {
        category: 'Korijeni',
        name: 'N-ti korijen',
        description: 'N-ti korijen iz X',
        latex: '\\kor[N]{X}'
    },
    {
        category: 'Postoci',
        name: 'Postotak',
        description: '70 posto od 200 jednako je 140',
        latex: '70 % od 200 =140'
    },
    {
        category: 'Omjeri',
        name: 'Omjeri',
        description: 'X prema Y jednako je 5 prema 1',
        latex: 'X :Y =5 :1',
    },
    {
        category: 'Omjeri',
        name: 'Omjeri i proporcije',
        description: '7 prema X jednako je Y prema 8',
        latex: '7 :X =Y :8'
    },
    {
        category: 'Veće, manje, jednako',
        name: 'Veće, manje, jednako',
        description: 'X je manje od 10',
        latex: 'X <10'
    },
    {
        category: 'Veće, manje, jednako',
        name: 'Veće, manje, jednako',
        description: 'Y je veće od 15',
        latex: 'Y >15'
    },
    {
        category: 'Veće, manje, jednako',
        name: 'Veće, manje, jednako',
        description: '10 je manje ili jednako X, a X je manje ili jednako 20',
        latex: '10 <=X <=20'
    },
    {
        category: 'Veće, manje, jednako',
        name: 'Veće, manje, jednako',
        description: '-20 je veće ili jednako Y, a Y je veće ili jednako -50',
        latex: '-20 >=Y >=-50'
    },
    {
        category: 'Sinusne funkcije',
        name: 'Sinusne funkcije',
        description: 'Sinus od X je jednak A kroz B',
        latex: '\\sin X =\\raz{A}{B}'
    },
]